import { callCloudFunction } from "../proxy/FirebaseFunctions";

export const requestContact = async (form: JSON): Promise<any> => {
  const response = await callCloudFunction("sendEmail", form);
  if (response.estado === "ERROR") {
    return "ERROR";
  }
  return "OK";
};
